import React from "react";
import * as d3 from "d3";

const LineGroup = ({xScale, yScale, getColor, data, ...props}) => {
  const ref = React.useRef(null);

  const line = d3.line()
    .x(d => xScale(new Date(d.year, d.month - 1, d.day)))
    .y(d => yScale(1500 + 100 * d.skill));

  React.useEffect( () => {
    d3.select(ref.current)
      .attr("opacity", 1)
      .selectAll('path')
      .data(data)
      .enter().append('path')
        .attr('d', player => line(player.curve))
        .attr('fill', 'none')
        .style('stroke-width', 2)
        .attr('stroke', player => getColor(player.player));
  }, [data]);


  return <g ref={ref} {...props}> </g>;
};

export default LineGroup;
